import React, { useEffect, useRef, useState } from 'react';
import { ScreenGreeting } from '../../../Components/Molecules';
import { Box, Button, Chip, Container, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import Tooltip from '../../../Components/Atoms/Tooltip';
import {
    MdCheck,
    MdError,
    MdSchedule,
    MdCalendarToday,
    MdFileDownload,
    MdFilterList,
    MdVisibility,
    MdClose,

} from 'react-icons/md'
import { makeStyles } from '@mui/styles';
import Grid2 from '@mui/material/Unstable_Grid2';
import api from '../../../Services/api';
import { Upload , TableChart, ViewList, NoteAdd, Save, FilterList as FilterListIcon } from "@mui/icons-material";
import styled from 'styled-components';
import {
    format
} from 'date-fns'
import { useToast } from '../../../Hooks/toast';
import { Link, Link as LinkRouter } from 'react-router-dom'
import { handleTaxIDInput } from '../../../Utils/masks';
import { formatInputValue } from '../../../Utils/formatInputValue';
import { simpleConvertToCents } from '../../../Utils/formatters';

const useStyle = makeStyles((theme) => ({
    dashboardItem: {
        height: '100px',
        padding: '15px 15px 0px 15px',
        display: 'flex',
        cursor: 'pointer',
        flexDirection: 'column'
    },
    dashboardItemTitle: {
        color: (theme as any).palette.primary.main
    },
    dashboardItemHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: '5px'
    },
    dashboardItemContent: {
        flex: 1,
        display: 'flex',
        alignItems: 'center'
    },
    dashboardItemIcon: {
        fontSize: 20
    },
    container: {
        marginTop: 1,
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 5
    }
}));

function toCurrency(val = 0) {
    return Intl.NumberFormat('pt-BR', { currency: 'BRL', style: 'currency' }).format(val);
}

export enum PaymentStatus {
    Analyze = "Analyze",
    Failed = 'Failed',
    Canceled = 'Canceled',
    AwaitingProcessing = 'AwaitingProcessing',
    Processed = 'Processed',
}

export const PaymentStatusLabels: Record<PaymentStatus, string> = {
    [PaymentStatus.Analyze]: 'Aguardando análise',
    [PaymentStatus.Failed]: 'Falha no processamento',
    [PaymentStatus.Canceled]: 'Cancelado',
    [PaymentStatus.AwaitingProcessing]: 'Aguardando processamento',
    [PaymentStatus.Processed]: 'Processado com sucesso',
};

export const PaymentStatusColors: Record<PaymentStatus, string> = {
    [PaymentStatus.Analyze]: '#0275d8',
    [PaymentStatus.Failed]: '#d9534f',
    [PaymentStatus.Canceled]: '#d9534f',
    [PaymentStatus.AwaitingProcessing]: '#f0ad4e',
    [PaymentStatus.Processed]: '#5cb85c',
};

const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        border-radius: 16px;
        box-shadow: 0 8px 24px rgba(0,0,0,.18);
    }
    .MuiDialogTitle-root {
        background: ${(props) => (props.theme as any).primary.original};
        color: #fff;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

const Payroll = () => {

    const styles = useStyle();

    const [isFilterOpen, setIsFilterOpen] = useState(false);

    const toast = useToast()

    const inputRef = useRef<HTMLInputElement>(null);
    const hasShownAnalyzeToast = useRef<boolean>(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [anchorE2, setAnchorE2] = React.useState<null | HTMLElement>(null);

    const [isManualOpen, setIsManualOpen] = useState(false);
    const [manualForm, setManualForm] = useState({
        name: '',
        document: '',
        amount: '',
        dateToPay: '',
        message: '',
        customerContract: '',
        customerIdProccessPayment: '',
        customerAdditionalInformation: ''
    });
    const [submittingManual, setSubmittingManual] = useState(false);

    const [payrolls, setPayrolls] = useState<{ totalRows: number, items: PayrollBatch[] }>({
        items: [],
        totalRows: 0
    });

    const [dashboard, setDashboard] = useState<DashboardResponse>({
        awaitingApproval: 0,
        quantityDenieds: 0,
        quantityErrors: 0,
        quantitySchedulled: 0,
        quantitySuccess: 0,
        quantityTotal: 0
    });

    const [filter, setFilter] = useState({
        page: 1,
        rowsPerPage: 5,
        dateCreatedStart: '',
        dateCreatedEnd: '',
        status: ''
    });

    const handleDownloadExemple = async (type = '',sampleType = '') => {
        const res = await api.get(`/payroll/sample/${type}/${sampleType}`, { responseType: 'blob' });
        const blobURL = URL.createObjectURL(res.data);

        const link = document.createElement('a');
        link.href = blobURL;
        if(sampleType!='complete')
            link.download = 'exemplo.' + type;
        else
            link.download = 'Folha_pagamento_colaboradores.' + type;
        link.click();
        setAnchorEl(null);
        setAnchorE2(null);
    };


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        await getAll();
        setIsFilterOpen(false);
    }

    const handleReset = async (e: React.FormEvent) => {
        e.preventDefault();

        setFilter(oldFilter => ({
            ...oldFilter,
            dateCreatedEnd: '',
            dateCreatedStart: '',
            status: ''
        }));
    }

    const getAll = async (filters: Record<string, any> = {}) => {
        const params = {
            page: filters.page,
            pagesize: filters.rowsPerPage,
            dateCreatedStart: filters.dateCreatedStart,
            dateCreatedEnd: filters.dateCreatedEnd,
            status: filters.status
        };

        const { data: { row_count = 0, items = [] } } = await api.get('/payroll/list', { params });

        setPayrolls({
            items,
            totalRows: row_count
        });

        try {
            if (items.length) {
                const analyzeItem = items.find((p: any) => p.status === 'Analyze');
                if (analyzeItem && !hasShownAnalyzeToast.current) {
                    toast.addToast({
                        type: 'info',
                        title: 'Folha aguardando aprovação',
                        description: 'Há folha de pagamento para sua aprovação.',
                        linkTo: `/payroll/${analyzeItem.id}`,
                        linkLabel: 'Ver detalhes',
                        duration: 12000,
                    });
                    hasShownAnalyzeToast.current = true;
                }
            }
        } catch (_) {
            // ignore toast errors
        }
    }
    const handleMenuClose = () => {
        setAnchorEl(null);
        setAnchorE2(null);
    };

    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputEl = e.currentTarget as HTMLInputElement;
        const file = inputEl.files?.item(0);

        if (!file) return;

        const sizeInMb = file.size / 1024 / 1024;

        if (!/.csv|.xlsx|.xls/gi.test(file.name)) {
            toast.addToast({
                title: 'Erro no arquivo',
                description: 'Arquivo deve ser XLSX, CSV ou XLS',
                type: 'error',
                duration: 12000,
            });
            // limpar para permitir reenvio do mesmo arquivo
            inputEl.value = '';
            return;
        }

        if (sizeInMb > 5) {
            toast.addToast({
                title: 'Erro no arquivo',
                description: 'Arquivo deve ter no máximo 5MB',
                type: 'error',
                duration: 12000,
            });
            // resetar input para permitir nova seleção
            inputEl.value = '';
            return;
        }

        const formdata = new FormData();

        formdata.append('file', file);

        const response = await api.post('/payroll', formdata);

        if (response.status % 200 < 99) {
            toast.addToast({
                title: 'Sucesso',
                description: 'Arquivo enviado com sucesso',
                type: 'success',
                duration: 12000,
            });

            getAll({ ...filter });
        }
        else {
            toast.addToast({
                title: 'Falha',
                description: 'Arquivo inválido',
                type: 'error',
                duration: 12000,
            });
        }
        // Limpa o input para permitir novo upload do mesmo arquivo
        inputEl.value = '';
    }

    const resetManualForm = () => {
        setManualForm({
            name: '',
            document: '',
            amount: '',
            dateToPay: '',
            message: '',
            customerContract: '',
            customerIdProccessPayment: '',
            customerAdditionalInformation: ''
        });
    }

    const handleManualSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (submittingManual) return;

        try {
            setSubmittingManual(true);

            const payload = {
                name: manualForm.name?.trim(),
                document: manualForm.document?.replace(/\D/g, ''),
                amount: Number(simpleConvertToCents(manualForm.amount)),
                dateToPay: manualForm.dateToPay || null,
                message: manualForm.message?.trim() || null,
                customerContract: manualForm.customerContract?.trim() || null,
                customerIdProccessPayment: manualForm.customerIdProccessPayment?.trim() || null,
                customerAdditionalInformation: manualForm.customerAdditionalInformation?.trim() || null,
            } as Record<string, any>;

            const response = await api.post('/payroll/manual', payload);

            if (response.status % 200 < 99) {
                toast.addToast({
                    title: 'Sucesso',
                    description: 'Pagamento adicionado com sucesso',
                    type: 'success',
                    duration: 12000,
                });
                // Mantém a modal aberta para novo cadastro
                resetManualForm();
                getAll({ ...filter });
            } else {
                toast.addToast({
                    title: 'Falha',
                    description: 'Não foi possível adicionar na folha de pagamento',
                    type: 'error',
                    duration: 12000,
                });
            }
        } catch (err: any) {
            toast.addToast({
                title: 'Erro',
                description: err?.response?.data?.message || 'Ocorreu um erro ao enviar os dados',
                type: 'error',
                duration: 12000,
            });
        } finally {
            setSubmittingManual(false);
        }
    }

    const getDashboard = async () => {
        const res = await api.get('/payroll/dashboard');

        if (res.status === 204) return;

        setDashboard(res.data);
    }

    useEffect(() => {
        getDashboard();
    }, []);

    useEffect(() => {
        getAll({ ...filter });
    }, [filter.page, filter.rowsPerPage]);

    const filterSelectedStatus = (status = '') => {
        const newFilter = { ...filter };

        newFilter.status = newFilter.status === status ? '' : status;

        setFilter(newFilter);
        getAll(newFilter);
    }


    return (
        <Box sx={{ lineHeight: '23px', boxSizing: 'border-box' }}>
            <ScreenGreeting
                title="Folha de pagamento"
                subTitle="Confira todas as informações da sua folha de pagamentos e selecione a modalidade de pagamento que melhor atende a sua necessidade."
            />

            <Paper sx={{ p: 2,pt:0,mt:0 }} >
                <Box>
                    <Typography sx={{ mb: 1 }} variant='h5'>Envio de arquivo para pagamento</Typography>
                    <p>
                        Adicione o pagamento usando nosso modelo em <b>csv</b> ou <b>excel</b>.
                        <br></br>
                        Você também pode testar seu arquivo na área de validação antes de fazer o envio para pagamento.
                    </p>
                </Box>
                <Box mt={3}>
                    <input type='file' accept='.xlsx,.csv,.xls' onChange={handleUpload} ref={inputRef} style={{ display: 'none' }} />
                    

                    <Button id="upload-button" style={{ color: 'white' }} onClick={() => { if(inputRef.current){ inputRef.current.value = ''; } inputRef.current?.click(); }} variant='contained'>
                        <Upload style={{ fontSize: 30 }} />
                        Enviar Pagamentos
                    </Button> 
                    <Button id="upload-button-manual" style={{ color: 'white' }} sx={{ ml: 2 }} variant='contained' onClick={() => setIsManualOpen(true)}>
                        <NoteAdd style={{ fontSize: 30 }} />
                        Inserir manualmente
                    </Button>
                    <br /><br />
                    <Button 
                        onClick={e => setAnchorEl(e.currentTarget)} 
                        variant='text'>
                        Baixar planilha exemplo
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem onClick={() => handleDownloadExemple('csv', 'example')}><ViewList style={{ fontSize: 25 }} sx={{ color: '#555' }} /> CSV</MenuItem>
                        <MenuItem onClick={() => handleDownloadExemple('xlsx', 'example')}><TableChart style={{ fontSize: 25 }} sx={{ color: '#008109' }} /> Excel - XLSX</MenuItem>
                    </Menu>

                    <br />
                    <Button 
                        onClick={e => setAnchorE2(e.currentTarget)} 
                        variant='text' 
                        title='Delete linhas ou deixe valores vazios/zerados para não lançar pagamento a colaboradores'>
                        Baixar planilha preenchida com seus colaboradores cadastrados
                    </Button>
                    <Menu
                        anchorEl={anchorE2}
                        open={Boolean(anchorE2)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem onClick={() => handleDownloadExemple('csv', 'complete')}><ViewList style={{ fontSize: 25 }} sx={{ color: '#555' }} /> CSV</MenuItem>
                        <MenuItem onClick={() => handleDownloadExemple('xlsx', 'complete')}><TableChart style={{ fontSize: 25 }} sx={{ color: '#008109' }} /> Excel - XLSX</MenuItem>
                    </Menu>

                </Box>
            </Paper>

            <Box sx={{ mt: 4, mb: 1 }}>
                <Typography variant='h5'>Arquivos enviados</Typography>
                <p>
                    Para aprovar o arquivo enviado, você precisa clicar no botão da coluna status ou no olho que está na primeira coluna.
                </p>
                <p>
                    Confira o status dos arquivos enviados ou agendados para processamento. Aguarde a análise e faça a correção em arquivos com erro.
                </p>
            </Box>

            <Grid2 spacing={2} container>
                <Grid2 xs={12} lg={3} md={6} >
                    <Paper style={{ border: filter.status === 'Processed' ? `1px solid ${PaymentStatusColors['Processed']}` : '' }} onClick={_ => filterSelectedStatus('Processed')} className={styles.dashboardItem}>
                        <div className={styles.dashboardItemHeader}>
                            <span style={{ color: PaymentStatusColors['Processed'] }} className={styles.dashboardItemTitle}>Processado</span>
                            <MdCheck color={PaymentStatusColors['Processed']} className={styles.dashboardItemIcon} />
                        </div>
                        <div className={styles.dashboardItemContent}>
                            {dashboard.quantitySuccess}
                        </div>
                    </Paper>
                </Grid2>
                <Grid2 xs={12} lg={3} md={6} >
                    <Paper style={{ border: filter.status === 'Analyze' ? `1px solid ${PaymentStatusColors['Analyze']}` : '' }} onClick={_ => filterSelectedStatus('Analyze')} className={styles.dashboardItem}>
                        <div className={styles.dashboardItemHeader}>
                            <span style={{ color: PaymentStatusColors['Analyze'] }} className={styles.dashboardItemTitle}>Em análise</span>
                            <MdSchedule color={PaymentStatusColors['Analyze']} className={styles.dashboardItemIcon} />
                        </div>
                        <div className={styles.dashboardItemContent}>
                            {dashboard.awaitingApproval}
                        </div>
                    </Paper>
                </Grid2>
                <Grid2 xs={12} lg={3} md={6} >
                    <Paper style={{ border: filter.status === 'AwaitingProcessing' ? `1px solid ${PaymentStatusColors['AwaitingProcessing']}` : '' }} onClick={_ => filterSelectedStatus('AwaitingProcessing')} className={styles.dashboardItem}>
                        <div className={styles.dashboardItemHeader}>
                            <span style={{ color: PaymentStatusColors['AwaitingProcessing'] }} className={styles.dashboardItemTitle}>Agendado</span>
                            <MdCalendarToday color={PaymentStatusColors['AwaitingProcessing']} className={styles.dashboardItemIcon} />
                        </div>
                        <div className={styles.dashboardItemContent}>
                            {dashboard.quantitySchedulled}
                        </div>
                    </Paper>
                </Grid2>
                <Grid2 xs={12} lg={3} md={6} >
                    <Paper style={{ border: filter.status === 'Failed' ? `1px solid ${PaymentStatusColors['Failed']}` : '' }} onClick={_ => filterSelectedStatus('Failed')} className={styles.dashboardItem}>
                        <div className={styles.dashboardItemHeader}>
                            <span style={{ color: PaymentStatusColors['Failed'] }} className={styles.dashboardItemTitle}>Com erro</span>
                            <MdError color={PaymentStatusColors['Failed']} className={styles.dashboardItemIcon} />
                        </div>
                        <div className={styles.dashboardItemContent}>
                            {dashboard.quantityErrors}
                        </div>
                    </Paper>
                </Grid2>
            </Grid2>

            <Box sx={{ mt: 4 }}>
                <Typography variant='h5' mb={1}>Histórico de lotes enviados</Typography>
                <Paper>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 1, py: 2 }}>
                        <Button onClick={() => setIsFilterOpen(true)}>
                            <MdFilterList />
                            <Box ml={1}>Filtros</Box>
                        </Button>
                    </Box>
                    <TableContainer sx={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>ID</TableCell>
                                    <TableCell>Arquivo</TableCell>
                                    <TableCell>Valor validado</TableCell>
                                    <TableCell>Valor pago</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Mensagem</TableCell>
                                    <TableCell>Data do crédito</TableCell>
                                    <TableCell>Criado em</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    !payrolls.items.length && (
                                        <TableRow>
                                            <TableCell colSpan={999}>
                                                <Typography align='center'>Não há pagamentos para serem exibidos.</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                                {
                                    payrolls.items.map(payroll => (
                                        <TableRow key={payroll.id}>
                                            <TableCell>
                                                <IconButton to={`/payroll/${payroll.id}`} component={LinkRouter}>
                                                    <MdVisibility />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell>{payroll.id}</TableCell>
                                            <TableCell>{payroll.fileName}</TableCell>
                                            <TableCell>{toCurrency(payroll.amountTotal)}</TableCell>
                                            <TableCell>{toCurrency(payroll.amountPayed)}</TableCell>
                                            <TableCell>

                                                <Chip
                                                    component={LinkRouter}
                                                    to={`/payroll/${payroll.id}`}
                                                    sx={{ color: '#FFF', backgroundColor: PaymentStatusColors[payroll.status], cursor: 'pointer' }}
                                                    label={PaymentStatusLabels[payroll.status]}
                                                />
                                            </TableCell>
                                            <TableCell>{payroll.message}</TableCell>
                                            <TableCell>{payroll.dateFinished && format(new Date(payroll.dateFinished), 'dd/MM/yyyy HH:mm')}</TableCell>
                                            <TableCell>{format(new Date(payroll.dateCreated), 'dd/MM/yyyy HH:mm')}</TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        onRowsPerPageChange={e => setFilter(oldPagination => ({ ...oldPagination, rowsPerPage: +e.target.value, page: 1 }))}
                        count={payrolls.totalRows}
                        rowsPerPage={filter.rowsPerPage}
                        page={filter.page - 1}
                        onPageChange={(ev, page) => setFilter(oldPagination => ({ ...oldPagination, page: page + 1 }))}
                    />
                </Paper>

            </Box>

            <StyledDialog open={isFilterOpen} fullWidth maxWidth={'md'} onClose={() => setIsFilterOpen(false)}>
                <DialogTitle>
                    <FilterListIcon /> Filtros
                </DialogTitle>
                <Tooltip title="Fechar">
                    <IconButton
                        aria-label="close"
                        onClick={() => setIsFilterOpen(false)}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[200],
                        })}
                    >
                        <MdClose />
                    </IconButton>
                </Tooltip>
                <DialogContent>
                    <Grid2 onSubmit={handleSubmit} onReset={handleReset} sx={{ mt: 1 }} component='form' id='frmFiltros' container spacing={3}>
                        <Grid2 xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Data Inicial"
                                InputLabelProps={{ shrink: true }}
                                type='date'
                                value={filter.dateCreatedStart}
                                onChange={e => setFilter(oldFilter => ({ ...oldFilter, dateCreatedStart: e.currentTarget.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Data Final"
                                InputLabelProps={{ shrink: true }}
                                type='date'
                                value={filter.dateCreatedEnd}
                                onChange={e => setFilter(oldFilter => ({ ...oldFilter, dateCreatedEnd: e.currentTarget.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12}>
                            <TextField
                                value={filter.status}
                                label="Status"
                                select
                                fullWidth

                                onChange={e => setFilter(oldFilter => ({ ...oldFilter, status: e.target.value }))}
                            >
                                {
                                    Object.entries(PaymentStatusLabels).map(([code, description]) => (
                                        <MenuItem value={code} key={code}>{description}</MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid2>
                    </Grid2>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Limpar filtros">
                        <span>
                            <Button type='reset' form='frmFiltros' variant='text'>Limpar</Button>
                        </span>
                    </Tooltip>
                    <Tooltip title="Aplicar filtros">
                        <span>
                            <Button type='submit' form='frmFiltros' variant='text'>Pesquisar</Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </StyledDialog>

            <StyledDialog open={isManualOpen} fullWidth maxWidth={'md'} onClose={() => { resetManualForm(); setIsManualOpen(false); }}>
                <DialogTitle>
                    <NoteAdd /> Adicionar folha de pagamento
                </DialogTitle>
                <Tooltip title="Fechar">
                    <IconButton
                        aria-label="close"
                        onClick={() => { resetManualForm(); setIsManualOpen(false); }}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[200],
                        })}
                    >
                        <MdClose />
                    </IconButton>
                </Tooltip>
                <DialogContent>
                    <Grid2 component='form' id='frmManualPayroll' container spacing={3} onSubmit={handleManualSubmit} onReset={(e) => { e.preventDefault(); resetManualForm(); }}>
                        <Grid2 xs={12} md={6}>
                            <TextField
                                required
                                fullWidth
                                label="Nome do colaborador"
                                value={manualForm.name}
                                onChange={e => setManualForm(prev => ({ ...prev, name: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <TextField
                                required
                                fullWidth
                                label="Documento (CPF/CNPJ)"
                                value={manualForm.document}
                                onChange={e => setManualForm(prev => ({ ...prev, document: handleTaxIDInput(e.target.value) }))}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <TextField
                                required
                                fullWidth
                                label="Valor do salário"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">R$</InputAdornment>
                                }}
                                value={manualForm.amount}
                                inputMode='numeric'
                                onChange={e => setManualForm(prev => ({ ...prev, amount: formatInputValue(e.target.value) }))}
                                helperText={manualForm.amount && Number(simpleConvertToCents(manualForm.amount)) < 0 ? 'Valor mínimo 0' : ' '}
                                error={manualForm.amount !== '' && Number(simpleConvertToCents(manualForm.amount)) < 0}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={6}>
                            <TextField
                                required
                                fullWidth
                                label="Data de pagamento"
                                type='date'
                                InputLabelProps={{ shrink: true }}
                                value={manualForm.dateToPay}
                                onChange={e => setManualForm(prev => ({ ...prev, dateToPay: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12}>
                            <Typography variant='body2' color='text.secondary'>
                                Os campos a seguir são opcionais.
                            </Typography>
                        </Grid2>
                        <Grid2 xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                minRows={2}
                                label="Observações"
                                value={manualForm.message}
                                onChange={e => setManualForm(prev => ({ ...prev, message: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Contrato do cliente"
                                value={manualForm.customerContract}
                                onChange={e => setManualForm(prev => ({ ...prev, customerContract: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="ID Processo 1 (cliente)"
                                value={manualForm.customerIdProccessPayment}
                                onChange={e => setManualForm(prev => ({ ...prev, customerIdProccessPayment: e.target.value }))}
                            />
                        </Grid2>
                        <Grid2 xs={12} md={4}>
                            <TextField
                                fullWidth
                                label="Informação adicional (cliente)"
                                value={manualForm.customerAdditionalInformation}
                                onChange={e => setManualForm(prev => ({ ...prev, customerAdditionalInformation: e.target.value }))}
                            />
                        </Grid2>
                    </Grid2>
                </DialogContent>
                <DialogActions>
                    <Tooltip title="Limpar formulário">
                        <span>
                            <Button type='reset' form='frmManualPayroll' variant='text'>Limpar</Button>
                        </span>
                    </Tooltip>
                    <Tooltip title="Cancelar e fechar">
                        <span>
                            <Button onClick={() => { resetManualForm(); setIsManualOpen(false); }} variant='text'>Cancelar</Button>
                        </span>
                    </Tooltip>
                    <Tooltip title="Salvar pagamento">
                        <span>
                            <Button disabled={submittingManual} type='submit' form='frmManualPayroll' variant='contained' style={{ color: 'white' }}>
                                <Save style={{ fontSize: 22 }} />
                                Salvar
                            </Button>
                        </span>
                    </Tooltip>
                </DialogActions>
            </StyledDialog>
        </Box>
    )
}

export default Payroll;